import { render, staticRenderFns } from "./QuestionAndAnswerWidget.vue?vue&type=template&id=0e32b00b"
import script from "./QuestionAndAnswerWidget.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswerWidget.vue?vue&type=script&lang=js"
import style0 from "./QuestionAndAnswerWidget.vue?vue&type=style&index=0&id=0e32b00b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports